import { render, staticRenderFns } from "./ApplicantChip.vue?vue&type=template&id=0b90026e&scoped=true"
import script from "./ApplicantChip.vue?vue&type=script&lang=ts"
export * from "./ApplicantChip.vue?vue&type=script&lang=ts"
import style0 from "./ApplicantChip.vue?vue&type=style&index=0&id=0b90026e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b90026e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b90026e')) {
      api.createRecord('0b90026e', component.options)
    } else {
      api.reload('0b90026e', component.options)
    }
    module.hot.accept("./ApplicantChip.vue?vue&type=template&id=0b90026e&scoped=true", function () {
      api.rerender('0b90026e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recruitings/ApplicantChip.vue"
export default component.exports